import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function CustomersPage({ apiBase = "/api" }) {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await fetch(`${apiBase}/customers/`);
        const data = await res.json();
        console.log(data);

        setCustomers(data);
      } catch (err) {
        console.error("Error fetching customers", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomers();
  }, [apiBase]);

  return (
    <Container className="mt-4">
      <h4 className="mb-3">Customers</h4>

      {loading ? (
        <Spinner />
      ) : (
        <Row className="g-3">
          {customers.map((c) => (
            <Col md={4} key={c.id}>
              <Card
                className="shadow-sm cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/customers/${c.id}`)}
              >
                <Card.Body>
                  <h4 style={{ color: "#0f0d03" }}>{c.name}</h4>
                  <div className="text-muted small">
                    {c.session_count || 0} Sessions
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
}
